
import React from 'react';
import { SelectItem } from '../../widgets/SelectItem';
import { EntityForm } from '../../widgets/Forms';
import ViewUtils from '../../ViewUtils';
import { makeStyles } from '@material-ui/core/styles';
import { CustomTextField } from '../../widgets/CustomTextField';
import { CustomDatePicker } from '../../widgets/CustomDatePicker';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const utils = new ViewUtils();
const OrganisationStakeholderEditForm = React.forwardRef((props, ref) => {
    const [tabValue, setTabValue] = React.useState(0);

    const styles = makeStyles({
        TextArea: {
            '& .MuiOutlinedInput-inputMultiline': {
                height: "200px !important",
                width: "600px !important"
            }
        }
    })


    return (
        <EntityForm ref={ref}
            dataURL='api/sims/organisationStakeholder/getfind'
            values={props.data}
            entityLookupId={props.id}
            entityLookupController={props.entityLookupController} org="saseta"
            useCustomSettings={false}
            dataArrivedHandler={props.dataArrivedHandler} valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="organisationStakeholderform">
                    <p className="legend">
                        {"Organisation Stakeholder Update"}
                    </p>
                    <table cellPadding="2" width="80%">
                        <tbody>
                            <tr>


                                <td>
                                    <CustomTextField
                                        id="FirstName"
                                        key={tabValue}
                                        label="First Name"
                                        className="w-100"
                                        form={form}
                                        disabled
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <CustomTextField
                                        id="Surname"
                                        key={tabValue}
                                        label="Surname"
                                        className="w-100"
                                        form={form}
                                        disabled
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <SelectItem
                                        dataUrl="api/sims/organisationStakeholder/GetLookupList?listId=FinancialYear"
                                        id="FinancialYearID"
                                        key={tabValue}
                                        label="Financial Year"
                                        className="w-100"
                                        required={true}
                                        form={form}
                                        disabled />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <SelectItem
                                        dataUrl="api/sims/organisationStakeholder/GetLookupList?listId=StakeholderRole"
                                        id="StakeholderRoleID"
                                        key={tabValue}
                                        label="StakeholderRole"
                                        className="w-100"
                                        required={true}
                                        form={form} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <SelectItem
                                        dataUrl="api/sims/organisationStakeholder/GetLookupList?listId=StakeholderStatus"
                                        id="StakeholderStatusID"
                                        key={tabValue}
                                        label="Stakeholder Status"
                                        className="w-100"
                                        required={true}
                                        form={form} />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            }
        </EntityForm>
    );
})

export default OrganisationStakeholderEditForm;